import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "@/i18n";
import LangSwitcher from "@/components/LangSwitcher";
import BookButton from "@/components/BookButton";

const LINKS = [
  { to: "/", key: "home" },
  { to: "/services", key: "services" },
  { to: "/personal-support", key: "personal" },
  { to: "/about", key: "about" },
  { to: "/packages", key: "packages" },
  { to: "/faq", key: "faq" },
  { to: "/contact", key: "contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { t } = useLang();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const linkClass = ({ isActive }) =>
    `text-sm tracking-wide transition-colors duration-300 ${isActive ? "text-gold" : "text-slate-300 hover:text-white"}`;

  return (
    <header data-testid="main-navigation" className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-obsidian/90 backdrop-blur-xl">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 sm:px-12 lg:px-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/assets/vck-logo-mark.png" alt="VCK Business Lab" className="h-11 w-auto" />
        </Link>
        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`nav-link-${l.key}`} className={linkClass}>
              {t(`nav.${l.key}`)}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-6 lg:flex">
          <LangSwitcher />
          <BookButton testid="nav-book-consultation-button" className="btn-gold !px-6 !py-2.5" />
        </div>
        <div className="flex items-center gap-4 lg:hidden">
          <LangSwitcher />
          <button
            data-testid="nav-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="text-white transition-colors hover:text-gold"
            aria-label="Toggle navigation menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-white/10 bg-obsidian px-6 py-8 lg:hidden">
          <nav className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-mobile-link-${l.key}`}
                className={linkClass}
              >
                {t(`nav.${l.key}`)}
              </NavLink>
            ))}
            <BookButton testid="nav-mobile-book-consultation-button" className="btn-gold mt-3 w-full" />
          </nav>
        </div>
      )}
    </header>
  );
}
